import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {Box, FormControl, Grid, InputLabel, Select, TextField} from "@material-ui/core";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {LoanRequestService} from "./LoanRequestService";
import {convertUniversalDateToPersianDate} from "../../utils/TimeConvertor";
import axios from "axios";
import {
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    convertToBirthDate
} from "../../utils/numberConvertor";
import DefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/DefaultDialogPage";
import {Alert, AlertTitle} from "@material-ui/lab";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler"

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import {Line} from 'react-chartjs-2';
import {LoansService} from "../LoinsList/LoansService";
import moment from "jalali-moment";
import {RaikoMoneyInputOutlined} from "@moeindal/base-raiko-panel-components";


const LoanRequestDetails = ({requestId}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new LoanRequestService(fundID, token, snackbar, loading)
    const loansService = new LoansService(fundID, token, snackbar, loading)


    useEffect(() => {
        if (requestId && requestId >= 0) {
            getDataFromServer()
        }
    }, [requestId])

    const [loanKindsList, setLoanKindsList] = useState([]);

    useEffect(() => {
        if (typeof loansService !== 'undefined' && loanKindsList.length === 0) {
            loansService.getLoanKinds()
                .then(response => {
                    setLoanKindsList(response)
                }).catch(reason => {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت لیست انواع وام ها!"))
            })
        }
    }, []);


    const [ownerFirstName, setOwnerFirstName] = useState("");
    const [ownerLastName, setOwnerLastName] = useState("");
    const [requesterFullName, setRequesterFullName] = useState("");
    const [accountCode, setAccountCode] = useState("");
    const [depositAccountId, setDepositAccountId] = useState(-1);
    const [sendAt, setSendAt] = useState("");
    const [loanKind, setLoanKind] = useState("");
    const [amount, setAmount] = useState("");
    const [installments, setInstallments] = useState("");

    const [loanAcceptedKind, setLoanAcceptedKind] = useState("نا مشخص");
    const [loanAcceptedAmount, setLoanAcceptedAmount] = useState("");
    const [loanAcceptedInstallmentsNumber, setLoanAcceptedInstallmentsNumber] = useState("نا مشخص");

    const [numberOfLoans, setNumberOfLoans] = useState("")
    const [numberOfMonthsOfWaiting, setNumberOfMonthsOfWaiting] = useState("")

    const [withdrawalAmountFromTheAccount, setWithdrawalAmountFromTheAccount] = useState(0);
    const [amountOfCommission, setAmountOfCommission] = useState(0);

    const [installmentsList, setInstallmentsList] = useState([]);


    const [submitAmount, setSubmitAmount] = useState("");
    const [submitDate, setSubmitDate] = useState("");
    const [submitInstallmentNumber, setSubmitInstallmentNumber] = useState("");
    const [submitLoanKinds, setSubmitLoanKinds] = useState(-1);

    const [loanInstallments, setLoanInstallments] = useState([]);

    const [bankAccountNumber, setBankAccountNumber] = useState("");
    const [IBAN, setIBAN] = useState("");

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Filler,
        Legend
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
        },
    };


    const [data, setData] = useState({datasets: []});

    function getDataFromServer() {
        loading(setLoadingStateDispatch(true))

        service.getLoanRequestDetail(requestId)
            .then(axios.spread((loanDetailResponse, loanInstallmentsResponse, loanOffersResponse) => {
                setAmount(loanDetailResponse.requestedAmount)
                setSubmitAmount(loanDetailResponse.requestedAmount)

                setAccountCode(loanDetailResponse.depositAccountNumber)
                setDepositAccountId(loanDetailResponse.depositAccountId)

                setLoanKind(loanDetailResponse.requestedLoanKind)

                setOwnerFirstName(loanDetailResponse.ownerFirstName)
                setOwnerLastName(loanDetailResponse.ownerLastName)
                setRequesterFullName(`${loanDetailResponse.requesterFirstName} ${loanDetailResponse.requesterLastName}`)
                setSendAt(convertUniversalDateToPersianDate(loanDetailResponse.sendAt))

                setInstallments(loanDetailResponse.requestedNumberOfInstallments)
                setSubmitInstallmentNumber(loanDetailResponse.requestedNumberOfInstallments)

                setStatusSelectState(loanDetailResponse.status)

                setBankAccountNumber(loanDetailResponse.bankAccountNumber)
                setIBAN(loanDetailResponse.IBAN)

                loading(setLoadingStateDispatch(false))

                loanDetailResponse.acceptedLoanKind && setLoanAcceptedKind(loanDetailResponse.acceptedLoanKind)
                loanDetailResponse.acceptedAmount && setLoanAcceptedAmount(loanDetailResponse.acceptedAmount)
                loanDetailResponse.acceptedNumberOfInstallments && setLoanAcceptedInstallmentsNumber(loanDetailResponse.acceptedNumberOfInstallments)

                setNumberOfLoans(loanDetailResponse.numberOfLoans)
                setNumberOfMonthsOfWaiting(loanDetailResponse.numberOfMonthsOfWaiting)

                setAmountOfCommission(loanInstallmentsResponse.amountOfCommission)
                setWithdrawalAmountFromTheAccount(loanInstallmentsResponse.withdrawalAmountFromTheAccount)
                setInstallmentsList(loanInstallmentsResponse.installments)

                if (loanOffersResponse && loanOffersResponse.items && loanOffersResponse.items[1]) {
                    const label = []
                    const amount = []
                    for (let i = 1; i <= 100; i++) {
                        label.push(i)
                        amount.push(loanOffersResponse.items[i])
                    }

                    setData({
                        labels: label,
                        datasets: [
                            {
                                fill: true,
                                label: 'وام',
                                data: amount,
                                borderColor: 'rgb(53, 162, 235)',
                                backgroundColor: 'rgba(53, 162, 235, 0.5)',
                            },
                        ],
                    })
                }


            })).catch(reject => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت جزئیات درخواست!"))
            loading(setLoadingStateDispatch(false))
        })
    }

    const [statusSelectState, setStatusSelectState] = useState("ACCEPTED");

    const [dialogConfirmRequestOpenState, setDialogConfirmRequestOpenState] = useState(false);
    const [dialogRejectRequestOpenState, setDialogRejectRequestOpenState] = useState(false);

    function closeDialogConfirmRequestOpenState() {
        setDialogConfirmRequestOpenState(false)
    }

    function closeDialogRejectRequestOpenState() {
        setDialogRejectRequestOpenState(false)
    }


    function rejectLoanRequest() {
        loading(setLoadingStateDispatch(true))
        service.rejectLoanRequest(requestId)
            .then(response => {
                setDialogRejectRequestOpenState(false)
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "درخواست وام با موفقیت رد شده."))
                setStatusSelectState("REJECTED")
                loading(setLoadingStateDispatch(false))
            }).catch(reject => {

            ServerErrorHandler(reject, "خطا در رد درخواست وام!", snackbar, loading)
        })
    }

    function acceptLoanRequest() {
        loading(setLoadingStateDispatch(true))

        service.acceptLoanRequest(requestId, submitLoanKinds, submitDate, submitAmount, submitInstallmentNumber)
            .then(response => {
                setDialogConfirmRequestOpenState(false)
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "درخواست وام با موفقیت ثبت شده."))
                setStatusSelectState("ACCEPTED")
                loading(setLoadingStateDispatch(false))
            }).catch(reject => {
            ServerErrorHandler(reject, "خطا در ثبت وام!", snackbar, loading)

        })
    }


    function prepareLoanInstallments() {
        if (checkPrepareLoanInstallmentConditions()) {
            loading(setLoadingStateDispatch(true))

            loansService.calculateLoan(fundID, depositAccountId, submitAmount, submitInstallmentNumber, submitLoanKinds, submitDate)
                .then(response => {
                    loading(setLoadingStateDispatch(false))
                    setLoanInstallments(response.installments)
                }).catch(reason => {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در محاسبه ی اقساط وام!"))
                loading(setLoadingStateDispatch(false))
            })
        }
    }

    function checkPrepareLoanInstallmentConditions() {
        let status = false;
        let message = ""

        if (submitLoanKinds < 0) {
            message = "لطفا نوع وام مورد نظر را انتخاب نمایید!"
        } else if (submitInstallmentNumber <= 0) {
            message = "لطفا تعداد اقساط وام را به درستی وارد نمایید!"
        } else if (submitDate.length !== 10) {
            message = "لطفا تاریخ ثبت وام را به درستی وارد نمایید!"
        } else if (submitAmount <= 0) {
            message = "لطفا مبلغ وام را به درستی وارد نمایید!"
        } else {
            status = true
        }

        if (message) {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        }
        return status;
    }

    return (
        <>
            <DefaultDialogPage
                onClose={closeDialogConfirmRequestOpenState}
                open={dialogConfirmRequestOpenState}
                pageTitle={"تایید وام"}
                dialogSize={DialogSize.LARGE}
            >
                <section
                    className={css`
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                      flex-grow: 1;
                      height: 100% !important;
                      padding: 1rem;
                    `}>

                    <Box className={"w-100"} sm={12}>
                        <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100 mt-3' sm={12}>
                            <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">نوع وام</InputLabel>
                                    <Select label="نوع وام*"
                                            value={submitLoanKinds}
                                            onChange={e => {
                                                setSubmitLoanKinds(e.target.value)
                                            }}
                                    >
                                        {loanKindsList && loanKindsList.map((item, index) => {
                                            return <option value={item.id} key={index}>{item.persianName}</option>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid sm={6} md={4} lg={2} xl={2} className='p-2 w-100'>
                                <TextField
                                    value={convertToBirthDate(submitDate)}
                                    onChange={({target}) => {
                                        setSubmitDate(convertToBirthDate(target.value))
                                    }}
                                    className='w-100'
                                    variant="outlined"
                                    label="تاریخ ثبت"/>
                            </Grid>
                            <Grid sm={6} md={4} lg={2} xl={2} className='p-2 w-100'>
                                <TextField
                                    value={submitInstallmentNumber}
                                    onChange={({target}) => {
                                        setSubmitInstallmentNumber(target.value)
                                    }}
                                    className='w-100'
                                    variant="outlined"
                                    label="تعداد اقساط"/>
                            </Grid>
                            <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                <TextField
                                    value={convertCurrencyFormat(submitAmount)}
                                    onChange={({target}) => {
                                        let currencyFormat = convertCurrencyFormat(target.value.replaceAll(",", ""));
                                        setSubmitAmount(currencyFormat.replaceAll(",", ""))
                                    }}
                                    className='w-100'
                                    variant="outlined"
                                    label="مبلغ وام"/>
                            </Grid>

                            <Grid sm={6} md={4} lg={2} xl={2} className='p-2 w-100'>
                                <button
                                    onClick={prepareLoanInstallments}
                                    className={"btn-confirm w-100"}>
                                    محاسبه اقساط
                                </button>
                            </Grid>
                        </Grid>
                    </Box>

                    <div className={css`
                      display: flex;
                      width: 100%;
                      flex-direction: column;
                      gap: 1rem;
                      flex-grow: 1;
                    `}>
                        {loanInstallments && loanInstallments.map((item, index) => {
                            return <Box className="cardCustom">
                                <Grid xs={6} sm={4} md={4} lg={1} xl={1}
                                      className="cardCustomContent p-2 w-100">
                                    <span className="cardCustomTitle">شماره قسط</span>
                                    <span
                                        className="cardCustomDescription">{item.numberOfInstallment}</span>
                                </Grid>
                                <Grid xs={6} sm={4} md={4} lg={2} xl={2}
                                      className="cardCustomContent p-2 w-100">
                                    <span className="cardCustomTitle">کارمزد (ریال)</span>
                                    <span
                                        className="cardCustomDescription">{
                                        convertCurrencyFormatPositiveNegative(item.amountOfCommission > 0 ? item.amountOfCommission : "0")}
                                            </span>
                                </Grid>
                                <Grid xs={6} sm={4} md={4} lg={2} xl={2}
                                      className="cardCustomContent p-2 w-100">
                                    <span className="cardCustomTitle">مبلغ (ریال)</span>
                                    <span
                                        className="cardCustomDescription">{convertCurrencyFormatPositiveNegative(item.amount)}</span>
                                </Grid>
                                <Grid xs={6} sm={4} md={4} lg={2} xl={2}
                                      className="cardCustomContent p-2 w-100">
                                    <span className="cardCustomTitle">مبلغ کمکی (ریال)</span>
                                    <span
                                        className="cardCustomDescription">{convertCurrencyFormatPositiveNegative(item.auxiliaryAmount > 0 ?
                                        item.auxiliaryAmount : "0")}</span>
                                </Grid>
                                <Grid xs={6} sm={4} md={4} lg={2} xl={2}
                                      className="cardCustomContent p-2 w-100">
                                    <span className="cardCustomTitle">مبلغ پرداختی(ریال)</span>
                                    <span
                                        className="cardCustomDescription">{convertCurrencyFormatPositiveNegative(item.payableAmount)}</span>
                                </Grid>
                                <Grid xs={6} sm={4} md={4} lg={2} xl={2}
                                      className="cardCustomContent p-2 w-100">
                                    <span className="cardCustomTitle">سررسید</span>
                                    <span
                                        className="cardCustomDescription">{moment(item.date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')}</span>
                                </Grid>
                            </Box>
                        })}
                    </div>

                    <div className={css`
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      justify-content: end;
                      align-items: end;
                      width: 100%;
                      gap: 1rem;
                      margin-top: 1rem;
                    `}>
                        <button
                            onClick={closeDialogConfirmRequestOpenState}
                            className={"btn-secondary"}>
                            انصراف
                        </button>
                        {loanInstallments && loanInstallments.length > 0 && <button
                            onClick={acceptLoanRequest}
                            className={"btn-confirm"}>
                            ثبت
                        </button>}
                    </div>
                </section>
            </DefaultDialogPage>

            <DefaultDialogPage
                onClose={closeDialogRejectRequestOpenState}
                open={dialogRejectRequestOpenState}
                pageTitle={"رد درخواست وام"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <section
                    className={css`
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                      padding: 1rem;
                    `}>
                    <Alert severity="warning" className={`warning-alert`}>
                        <AlertTitle>آیا از رد درخواست وام اطمینان دارید؟!</AlertTitle>
                        <div className={css`display: flex;
                          flex-direction: column;
                          gap: 8px;
                        `}>
                            <span>با اتمام فرایند، درخواست رد شده و قابل بازگشت نخواهد بود!</span>
                        </div>
                    </Alert>
                    <div className={css`
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      width: 100%;
                      gap: 1rem;
                      margin-top: 1rem;
                    `}>
                        <button
                            onClick={closeDialogRejectRequestOpenState}
                            className={"btn-secondary w-100"}>
                            انصراف
                        </button>
                        <button
                            onClick={rejectLoanRequest}
                            className={"btn-confirm w-100"}>
                            ثبت
                        </button>
                    </div>
                </section>
            </DefaultDialogPage>
            <section className={css`padding: 1rem;`}>
                <Box className="w-100" sm={12}>
                    <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}>

                        <Grid
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            className={css`direction: ltr;
                              max-height: 50vh;
                              max-width: 100vw;
                              overflow-x: auto;
                              overflow-y: hidden;
                              margin-bottom: 1rem;
                            `}>
                            {data && data.datasets && data.datasets.length > 0 ?
                                <Line className={css`max-height: 50vh`} options={options} data={data} type={""}/> : ""}
                        </Grid>
                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={requestId} className='w-100' variant="outlined" disabled={true}
                                       label="شناسه درخواست"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={ownerFirstName} className='w-100' variant="outlined" disabled={true}
                                       label="نام"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={ownerLastName} className='w-100' variant="outlined" disabled={true}
                                       label="نام خانوادگی"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={accountCode} className='w-100' variant="outlined" disabled={true}
                                       label="شماره حساب"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={requesterFullName} className='w-100' variant="outlined" disabled={true}
                                       label="درخواست کننده"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={sendAt} className='w-100' variant="outlined" disabled={true}
                                       label="تاریخ درخواست"/>
                        </Grid>

                        <Grid sm={12} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField
                                value={loanKind}
                                className='w-100'
                                variant="outlined"
                                disabled={true}
                                label="نوع وام درخواستی"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={installments} className='w-100' variant="outlined" disabled={true}
                                       label="تعداد اقساط درخواستی"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <RaikoMoneyInputOutlined
                                setValue={_ => {
                                }}
                                labelText={"مبلغ درخواستی (ریال)"}
                                value={amount}
                                className='w-100'
                                variant="outlined"
                                disabled={true}
                                label="مبلغ درخواستی (ریال)"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={numberOfLoans} className='w-100' variant="outlined"
                                       disabled={true}
                                       label="تعداد وام ها"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={numberOfMonthsOfWaiting} className='w-100' variant="outlined"
                                       disabled={true}
                                       label="ماه انتظار"/>
                        </Grid>

                        <Grid sm={12} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={loanAcceptedKind} className='w-100' variant="outlined" disabled={true}
                                       label="نوع وام تایید شده"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={loanAcceptedInstallmentsNumber} className='w-100' variant="outlined"
                                       disabled={true}
                                       label="تعداد اقساط تایید شده"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={convertCurrencyFormat(loanAcceptedAmount)} className='w-100'
                                       variant="outlined"
                                       disabled={true}
                                       label="مبلغ تایید شده (ریال)"/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <RaikoMoneyInputOutlined
                                setValue={_ => {
                                }}
                                value={amountOfCommission}
                                className={'w-100'}
                                variant="outlined"
                                disabled={true}
                                labelText={"مبلغ کمیسیون (ریال)"}/>
                        </Grid>

                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={convertCurrencyFormat(withdrawalAmountFromTheAccount)} className='w-100'
                                       variant="outlined"
                                       disabled={true}
                                       label="مبلغ کمکی از حساب (ریال)"/>
                        </Grid>

                        <Grid xs={12} sm={6} md={4} lg={4} xl={3}>
                            <FormControl variant="outlined" className="p-2 w-100">
                                <InputLabel htmlFor="filled-age-native-simple">وضعیت</InputLabel>
                                <Select label="وضعیت"
                                        value={statusSelectState}
                                        onChange={e => {
                                            setStatusSelectState(e.target.value)
                                        }}
                                        disabled={true}
                                >
                                    <option value={"AWAITING_FOR_REVIEW"}>در حال بررسی</option>
                                    <option value={"ACCEPTED"}>پذیرفته شده</option>
                                    <option value={"REJECTED"}>رد شده</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                            <TextField value={bankAccountNumber} className='w-100'
                                       variant="outlined"
                                       disabled={true}
                                       label="شماره حساب"/>
                        </Grid>
                        <Grid sm={12} md={8} lg={8} xl={12} className='p-2 w-100'>
                            <TextField value={IBAN} className='w-100'
                                       variant="outlined"
                                       disabled={true}
                                       label="شماره شبا"/>
                        </Grid>

                        <Grid sm={12}>
                            <span
                                className={installmentsList.length > 0 ? "w-100 p-2 fs-3" : "d-none"}>جزئيات اقساط</span>
                            {
                                installmentsList.map((item, index) => {
                                    return <Box className="cardCustom">
                                        <Grid xs={6} sm={4} md={4} lg={3} xl={3}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">#</span>
                                            <span className="cardCustomDescription">{index + 1}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={3} xl={3}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">تاریخ سر رسید</span>
                                            <span
                                                className="cardCustomDescription">{convertUniversalDateToPersianDate(item.date)}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={3} xl={3}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">مبلغ(ریال)</span>
                                            <span
                                                className="cardCustomDescription">{convertCurrencyFormat(item.amount)}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={3} xl={3}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">مبلغ قابل پرداخت (ریال)</span>
                                            <span
                                                className="cardCustomDescription">{convertCurrencyFormat(item.payableAmount)}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={3} xl={3}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">مبلغ کمکی</span>
                                            <span className="cardCustomDescription">
                                            {item.includesAuxiliaryAmount ? "دارد" : "ندارد"}
                                        </span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={3} xl={3}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">مبلغ کمکی (ریال)</span>
                                            <span className="cardCustomDescription">{item.auxiliaryAmount}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={3} xl={3}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">وضعیت اعمال کمکی</span>
                                            <span
                                                className="cardCustomDescription">{item.appliedAuxiliaryAmount ? "اعمال شده" : "اعمال نشده"}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={3} xl={3}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">کمیسیون (ریال)</span>
                                            <span className="cardCustomDescription">{item.amountOfCommission}</span>
                                        </Grid>
                                    </Box>
                                })
                            }
                        </Grid>
                        <div className={
                            css`display: flex;
                              flex-direction: row;
                              flex-wrap: nowrap;
                              gap: 1rem;
                              margin-top: 1rem;
                              justify-content: end;
                              align-items: end;
                              width: 100%;
                            `
                        }>

                            {statusSelectState === "AWAITING_FOR_REVIEW" &&
                                <button
                                    onClick={_ => {
                                        setDialogRejectRequestOpenState(true)
                                    }}
                                    className={"btn-secondary"}>
                                    رد درخواست
                                </button>
                            }

                            {
                                <button
                                    onClick={_ => {
                                        setDialogConfirmRequestOpenState(true)
                                    }}
                                    className={"btn-confirm"}>
                                    تایید درخواست
                                </button>}
                        </div>
                    </Grid>
                </Box>
            </section>
        </>
    )
}

export default LoanRequestDetails